import customaxios from ".";

export const getOrderSummaryById = (orderId: number) => {
  return customaxios({
    method: "GET",
    url: `/orders/summary/${orderId}`,
  });
};

export const postContinueToOrder = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/orders/continue`,
    data,
  });
};

export const deleteOrderItemByServiceId = (
  orderId: number,
  serviceId: number,
) => {
  return customaxios({
    method: "DELETE",
    url: `/orders/${orderId}`,
    params: {
      serviceId: serviceId,
    },
  });
};

export const deleteOrderItemByOrderItemId = (
  orderId: number,
  orderItemId: number,
) => {
  return customaxios({
    method: "DELETE",
    url: `/orders/${orderId}`,
    params: {
      orderItemIds: orderItemId,
    },
  });
};

export const createOrderFromCart = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/orders/create`,
    data,
  });
};

export const getUserBillingDetails = () => {
  return customaxios({
    method: "GET",
    url: `/user/billing-details`,
  });
};

export const updateUserBillingDetails = (billingId: number, data: any) => {
  return customaxios({
    method: "PUT",
    url: `/user/billing-details/${billingId}`,
    data,
  });
};

export const createUserBillingDetails = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/user/billing-details`,
    data,
  });
};

export const cancelUserOrder = (id: number, timezone: any) => {
  return customaxios({
    method: "PATCH",
    url: `/orders/${id}/cancel`,
    params: {
      timezone: timezone,
    },
  });
};

export const userInvoiceDownload = (orderId: number, timezone: any) => {
  return customaxios({
    method: "GET",
    url: `/orders/${orderId}/invoice/download`,
    params: {
      timezone: timezone,
    },
    responseType: "blob",
  });
};

export const getUserOrderDetails = (id: number) => {
  return customaxios({
    method: "GET",
    url: `/orders/${id}`,
  });
};

export const getUserOrders = (sort: string) => {
  return customaxios({
    method: "GET",
    url: `/user/orders/`,
    params: {
      sort: sort,
    },
  });
};

export const updateServiceDate = (orderId: number, data: any) => {
  return customaxios({
    method: "PUT",
    url: `/orders/service-date/${orderId}`,
    data,
  });
};
export const postContinueToOrderPlanner = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/orders/planner/continue`,
    data,
  });
};


export const createOrdersFromCartPlanner = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/orders/planner/create`,
    data,
  });
};

export const completeOrderWithoutPayment = (orderId: number) => {
  return customaxios({
    method: "POST",
    url: `/orders/complete-without-payment/${orderId}`,
  });
};
